/*
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-20 17:00:03
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-20 17:00:11
 * @FilePath: \partner.chaoyongtuan.com\src\plugins\bus.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
const Bus = new Vue();
export default Bus;
